import React from 'react';
import UbiWithdrawBottomSheet, {UbiWithdrawBottomSheetProps} from '@di-shared/features/ubi/UbiWithdrawBottomSheet';
import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 300;

function UbiWithdrawBottomPage() {
  const {vin, serviceId, agreeInfo} = (window as any).data as UbiWithdrawBottomSheetProps;

  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
      <UbiWithdrawBottomSheet
        vin={vin}
        serviceId={serviceId}
        agreeInfo={agreeInfo}
      />
    </BottomSheetWebViewWrapper>
  );
}

export default UbiWithdrawBottomPage;
